export class ClaudeEnterpriseSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apiKeyMasked",
            "baseName": "apiKeyMasked",
            "type": "string",
            "format": ""
        },
        {
            "name": "keyScopes",
            "baseName": "keyScopes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "keyVerifiedAt",
            "baseName": "keyVerifiedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
